// extracted by mini-css-extract-plugin
module.exports = {"subHeader":"ViewsCommon_subHeader__3o10y","main":"ViewsCommon_main__3aJpJ"};